// Import utilities
import { itemsObject } from '@builder/common/utilities';
import { convertDelayToSeconds, convertDateToSortableInteger } from '@builder/item/schedule/utilities';
const { isDefined } = _uo.utility;

/**
 * Adds a property to all actions to easily recognize that they have actions
 *
 * @return {undefined}
 */
const flagActionsScheduled = () => {
	// Get recipe actions
	const actions = itemsObject( 'get', {
		filter: {
			itemType: 'action',
		},
	} );

	// Add the default flag to all actions
	// The default flag is false
	for ( const actionId in actions ) {
		const actionMeta = UncannyAutomator.recipe.items[ actionId ].meta;

		// Check if it has the meta that only scheduled/delayed actions have
		UncannyAutomator.recipe.items[ actionId ].isScheduled = isDefined( actionMeta[ 'async_mode' ] ) && actionMeta[ 'async_mode' ] == 'schedule';
		UncannyAutomator.recipe.items[ actionId ].isDelayed = isDefined( actionMeta[ 'async_mode' ] ) && actionMeta[ 'async_mode' ] == 'delay';

		// Add data to make these actions sortable
		if ( UncannyAutomator.recipe.items[ actionId ].isScheduled ) {
			UncannyAutomator.recipe.items[ actionId ].scheduleNumber = convertDateToSortableInteger( actionMeta[ 'async_schedule_date' ], actionMeta[ 'async_schedule_time' ] );
		}

		if ( UncannyAutomator.recipe.items[ actionId ].isDelayed ) {
			UncannyAutomator.recipe.items[ actionId ].delayInSeconds = convertDelayToSeconds( actionMeta[ 'async_delay_number' ], actionMeta[ 'async_delay_unit' ] );
		}
	}
};

export default flagActionsScheduled;
